import { TwoColumn } from '@src/layout';

import AbsenceTimeline from './AbsenceTimeline';


function Absence() {
  return <TwoColumn primary={<AbsenceTimeline />} />;
}

Absence.displayName = 'Absence';
export default Absence;
